import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import { DateTimePicker } from "@material-ui/pickers";
import { Grid } from "@material-ui/core";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocModal from "../../../utils/MeditocModal";
import { useEmpresa } from "../../../../context/EmpresaContext";

export default function ModificarVigencia() {
    const {
        modalOpenModificarVigencia,
        formVigencia,
        handleOpenModificarVigencia,
        handleChangeVigencia,
        handleSubmitModificarVigencia,
    } = useEmpresa();

    const { dtpFechaVigencia } = formVigencia;

    return (
        <MeditocModal
            title="Extender la vigencia de los folios"
            size="small"
            open={modalOpenModificarVigencia}
            setopen={handleOpenModificarVigencia}
            okfunc={handleSubmitModificarVigencia}
            form
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <DateTimePicker
                        name="dtpFechaVigencia"
                        label={dtpFechaVigencia.label}
                        required={dtpFechaVigencia.required}
                        value={dtpFechaVigencia.value}
                        error={dtpFechaVigencia.error}
                        helperText={dtpFechaVigencia.error && dtpFechaVigencia.message}
                        onChange={(date) => handleChangeVigencia(date, "dtpFechaVigencia")}
                        views={["year", "month", "date", "hours", "minutes"]}
                        InputProps={{ endAdornment: <MeditocDateIcon /> }}
                        inputVariant={inputVariant}
                        format="dd/MM/yyy hh:mm a"
                        color={inputColor}
                        openTo="year"
                        disablePast
                        fullWidth
                        autoOk={true}
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
